import _app from '../../../server';

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
    PictureAdapter
} from 'components/elements'

import {
    Row, Col
} from 'reactstrap';

import {
    faCaretSquareRight,
    faCaretSquareLeft
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { library } from '@fortawesome/fontawesome-svg-core'
library.add(faCaretSquareRight)
library.add(faCaretSquareLeft)

class PictureScroller extends Component {
    static propTypes = {
        pictures: PropTypes.array
    }

    constructor(props) {
        super(props);
        this.state = {
            selectedId: 0,
            startIndex: 0,
            lastIndex: 0,
            icoLeftScale: 'grow-0',
            icoRightScale: 'grow-0',
            icoLeftStyle: {
                cursor: 'hand',
                color: 'gray'
            },
            icoRightStyle: {
                cursor: 'hand',
                color: 'gray'
            },
            currentPage: 1
        }
    }


    componentDidMount() {
        const { pictures } = this.props
        if (pictures.length !== 0) {
            if (pictures.length > 4) {
                this.setState({
                    lastIndex: 4,
                    selectedId: pictures[0].id
                })
            } else {
                this.setState({
                    lastIndex: pictures.length,
                    selectedId: pictures[0].id
                })
            }
        }
    }

    onPictureSelected = (id) => {
        this.setState({ selectedId: id });
    }



    onIcoLeftClicked = () => {
        if (this.state.currentPage === 1) {
            return;
        }
        const { pictures } = this.props;

        let currentPage = this.state.currentPage - 1;
        let startIndex = (currentPage * 4) - 4;
        let lastIndex = startIndex + 4;
        if (lastIndex > pictures.length) {
            lastIndex = pictures.length;
        }
        let selectedId = pictures[lastIndex - 1].id
        this.setState({
            startIndex: startIndex,
            lastIndex: lastIndex,
            selectedId: selectedId,
            currentPage: currentPage
        });
    }
    onLeftMouseOver = () => {
        if (this.state.currentPage === 1) {
            this.setState({
                icoLeftStyle: {
                    cursor: 'not-allowed',
                    color: 'gray'
                },
                icoLeftScale: 'grow-0'
            })
            return;
        }
        this.setState({
            icoLeftStyle: {
                cursor: 'hand',
                color: 'green'
            },
            icoLeftScale: 'grow-6'
        });
    }
    onLeftMouseOut = () => {
        this.setState({
            icoLeftStyle: {
                cursor: 'hand',
                color: 'gray'
            },
            icoLeftScale: 'grow-0'
        })
    }


    onIcoRightClicked = () => {
        const { pictures } = this.props;

        let pageCount = Math.round(pictures.length / 4);

        if (this.state.currentPage + 1 > pageCount) {
            return;
        }
        let currentPage = this.state.currentPage + 1;

        let startIndex = (currentPage * 4) - 4;
        let lastIndex = startIndex + 4;
        if (lastIndex > pictures.length) {
            lastIndex = pictures.length;
        }
        let selectedId = pictures[lastIndex - 1].id
        this.setState({
            startIndex: startIndex,
            lastIndex: lastIndex,
            selectedId: selectedId,
            currentPage: currentPage
        });
    }
    onRightMouseOver = () => {
        const { pictures } = this.props;
        let pageCount = Math.round(pictures.length / 4);
        if (this.state.currentPage + 1 > pageCount) {
            this.setState({
                icoRightStyle: {
                    cursor: 'not-allowed',
                    color: 'gray'
                },
                icoRightScale: 'grow-0'
            })
            return;
        }
        this.setState({
            icoRightStyle: {
                cursor: 'hand',
                color: 'green'
            },
            icoRightScale: 'grow-6'
        });
    }
    onRightMouseOut = () => {
        this.setState({
            icoRightStyle: {
                cursor: 'hand',
                color: 'gray'
            },
            icoRightScale: 'grow-0'
        })
    }

    render() {
        //console.log("PictureScroller : ", this.props.pictures);

        let storage = JSON.parse(localStorage.getItem("guardexpert_logon"));
        let img_link;
        this.props.pictures.forEach(p => {
            if (p.id === this.state.selectedId) {
                if (p.container !== null && p.filename !== null) {
                    img_link = `${_app.api}Storages/${p.container}/download/${p.filename}?access_token=${storage.info.id}`
                }
            }
        });

        return (
            <div className="img-thumbnail border-0">
                <img src={img_link} alt="Evidence" style={{ height: "400px", display: "block", maxWidth: "100%", margin: "auto" }}></img>
                <Row>
                    <Col xs="3" md="2" className="text-left m-auto">
                        <FontAwesomeIcon
                            icon="caret-square-left"
                            size="2x"
                            onClick={this.onIcoLeftClicked}
                            style={this.state.icoLeftStyle}
                            onMouseOver={this.onLeftMouseOver}
                            onMouseOut={this.onLeftMouseOut}
                            transform={this.state.icoLeftScale}
                        />
                    </Col>
                    <Col xs="6" md="8" className="text-center">
                        <Row>
                            <PictureAdapter
                                pictures={this.props.pictures}
                                onSelected={this.onPictureSelected}
                                selectedId={this.state.selectedId}
                                startIndex={this.state.startIndex}
                                lastIndex={this.state.lastIndex}
                            />
                        </Row>
                    </Col>
                    <Col xs="3" md="2" className="text-right m-auto">
                        <FontAwesomeIcon
                            icon="caret-square-right"
                            size="2x"
                            onClick={this.onIcoRightClicked}
                            style={this.state.icoRightStyle}
                            onMouseOver={this.onRightMouseOver}
                            onMouseOut={this.onRightMouseOut}
                            transform={this.state.icoRightScale}
                        />
                    </Col>
                </Row>
            </div>
        )
    }
}


export default PictureScroller



// WEBPACK FOOTER //
// ./src/components/features/PictureScroller/PictureScroller.js